import type { SubscriptionPlan } from '../types/subscription';

export const SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
  {
    id: 'tezhly_plus',
    name: 'Tezhly: Career Labs',
    description: 'Full platform access for individuals',
    price: 3999, // $39.99
    interval: 'monthly',
    stripe_price_id: 'price_1R0SezJS08trBicY6pK6Uqoo',
    features: [
      'Access to community feed',
      'Access to course catalog',
      'Public profile',
      'Full access to job board',
      'Private Career Coaching',
      'Priority job applications',
      'Resume Review Sessions'
    ],
    is_active: true
  },
  {
    id: 'business_plan',
    name: 'Business',
    description: 'Perfect for small businesses and startups',
    price: 4900,
    interval: 'monthly',
    stripe_price_id: 'price_1QoUgOJS08trBicYZOmUOuwr',
    features: [
      'Access to intern talent pool',
      'Post unlimited job listings',
      'Customized intern matching',
      'Internship program resources',
      'Priority support',
      'All Pro features included'
    ],
    is_active: true
  },
];